module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-page",
    attrs: {
      "id": "treatments"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "col-12 page-title"
  }, [_vm._v("\n      TRAITEMENTS & AVIS\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row",
    attrs: {
      "id": "treatments-and-review-content"
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 pb-5 section-title text-left",
    class: {
      sticky: _vm.stickyReviews
    },
    attrs: {
      "id": "review-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "review-section"
    }
  }, [_c('GoogleReviews')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-8 section-title",
    class: {
      'offset-lg-4': _vm.stickyReviews
    },
    attrs: {
      "id": "treatments-content"
    }
  }, [_c('h1', {
    staticClass: "pb-1"
  }, [_vm._v("TRAITEMENTS PROPOSÉS")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "mt-5 pb-1"
  }, [_vm._v("Il me manque une dent, puis-je poser un implant ? En quoi consiste-t-il ?")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('div', [_vm._v("S’il vous manque une seule dent, l’implant sera donc l’alternative idéale au bridge sans léser les dents environnantes. C’est une vis qui joue le rôle d’une racine artificielle. Ainsi grâce à l’implant, la restauration ne prendra pas appui sur d’autres dents. Ce traitement préservera votre capital dentaire. Dans un secteur terminal, l’implant sera la seule alternative à la prothèse amovible.")]), _vm._v(" "), _c('div', {
    staticClass: "pt-2"
  }, [_vm._v("Les implants dentaires s'apparentent à une vis, généralement en titane, placée dans l'os maxillaire ou mandibulaire. L'implant dentaire seul ne suffit pas pour remplacer une dent. Un pilier prothétique sur mesure ou infrastructure doit ensuite être installé sur l’implant (4 à 6 mois après la pose de l’implant), il permet la connexion entre l’implant et la future prothèse. Une couronne implanto-portée (ou prothèse) sera ensuite placée sur le pilier prothétique.")]), _vm._v(" "), _c('div', {
    staticClass: "treatment-images col-xs-12 col-lg-10"
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "height": "fit-content",
      "hide-delimiter-background": "",
      "hide-delimiters": "",
      "interval": "100000",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.treatmentImages_1), function(treatmentImage, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('v-card', [_c('v-img', {
      attrs: {
        "src": treatmentImage.src,
        "height": "fit-content"
      }
    }), _vm._v(" "), _c('v-card-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getFileName(treatmentImage.src)))])], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Et s’il me manque plusieurs dents ?")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_vm._v("\n          De la même manière, ils peuvent remplacer plusieurs dents voire la denture en entier. Cela peut passer par 4, 6, 8 ou 10 implants selon la situation clinique.\n\n          "), _c('div', {
    staticClass: "treatment-images col-xs-12 col-lg-10"
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "height": "fit-content",
      "hide-delimiter-background": "",
      "hide-delimiters": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.treatmentImages_2), function(treatmentImage, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('v-card', [_c('v-img', {
      attrs: {
        "src": treatmentImage.src,
        "height": "fit-content"
      }
    }), _vm._v(" "), _c('v-card-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getFileName(treatmentImage.src)))])], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', [_vm._v("Et s’il me manque de l’os pour poser les implants ?")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('div', [_vm._v("Selon la situation clinique, il se peut que l’os initial ne suffise pas à poser l’implant dans les bonnes conditions. Il est donc parfois nécessaire de préparer le terrain osseux avant ou en même temps que la pose d’implant selon le cas.")]), _vm._v(" "), _c('div', {
    staticClass: "pt-2"
  }, [_vm._v("Il existe plusieurs défauts osseux et donc plusieurs reconstructions (ou greffes possibles):")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n              Défaut dans le sens vertical de la mâchoire supérieure au niveau des sinus qui nécessite un sinus lift en modifiant la limite du sinus et en comblant l’espace vide créé :\n\n              "), _c('div', {
    staticClass: "treatment-images col-xs-12 col-lg-10"
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "height": "fit-content",
      "hide-delimiter-background": "",
      "hide-delimiters": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.treatmentImages_3), function(treatmentImage, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('v-card', [_c('v-img', {
      attrs: {
        "src": treatmentImage.src,
        "height": "fit-content"
      }
    }), _vm._v(" "), _c('v-card-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getFileName(treatmentImage.src)))])], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _c('li', [_vm._v("\n              Défaut dans le sens de la largeur : qui peut se faire de différentes techniques (utilisation de votre propre os, d’un mélange de votre os et d’un substitut osseux ou d’un substitut osseux seul) par des Reconstructions Osseuses Guidées (ROG) stabilisées par des pins ou reconstruction osseuse par coffrage.\n\n              "), _c('div', {
    staticClass: "treatment-images col-xs-12 col-lg-10"
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "height": "fit-content",
      "hide-delimiter-background": "",
      "hide-delimiters": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.treatmentImages_4), function(treatmentImage, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('v-card', [_c('v-img', {
      attrs: {
        "src": treatmentImage.src,
        "height": "fit-content"
      }
    }), _vm._v(" "), _c('v-card-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getFileName(treatmentImage.src)))])], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _c('li', [_vm._v("\n              Défaut dans le sens de la hauteur et/ou combiné à un défaut dans le sens de la largeur : peut être traité par les mêmes techniques décrites précédemment.\n\n              "), _c('div', {
    staticClass: "treatment-images col-xs-12 col-lg-10"
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "height": "fit-content",
      "hide-delimiter-background": "",
      "hide-delimiters": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.treatmentImages_5), function(treatmentImage, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('v-card', [_c('v-img', {
      attrs: {
        "src": treatmentImage.src,
        "height": "fit-content"
      }
    }), _vm._v(" "), _c('v-card-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getFileName(treatmentImage.src)))])], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _c('li', [_vm._v("\n              Comblement osseux : afin d’éviter les techniques décrites précédemment (qui peuvent être lourdes et difficiles à mettre en œuvre), un comblement avec des substituts osseux de l’alvéole simultanément à l’avulsion de la dent peut vous être proposé. Mieux vaut prévenir que guérir !\n\n              "), _c('div', {
    staticClass: "treatment-images col-xs-12 col-lg-10"
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "height": "fit-content",
      "hide-delimiter-background": "",
      "hide-delimiters": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.treatmentImages_6), function(treatmentImage, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('v-card', [_c('v-img', {
      attrs: {
        "src": treatmentImage.src,
        "height": "fit-content"
      }
    }), _vm._v(" "), _c('v-card-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getFileName(treatmentImage.src)))])], 1)], 1)
  }), 1)], 1)])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', [_vm._v("Mes gencives se déchaussent, peut on faire quelque chose ?")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('div', [_vm._v("Si vos gencives se déchaussent cela veut dire qu’il y a une cause sous jacente, qu’il faut traiter avant toute chirurgie par des séances de nettoyage.")]), _vm._v(" "), _c('div', {
    staticClass: "pt-2"
  }, [_vm._v("Par la suite des reconstructions de gencive peuvent être envisagées et différentes techniques peuvent être proposées selon la situation clinique.")]), _vm._v(" "), _c('div', {
    staticClass: "treatment-images col-xs-10 col-lg-8"
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "height": "fit-content",
      "hide-delimiter-background": "",
      "hide-delimiters": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.treatmentImages_7), function(treatmentImage, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('v-card', [_c('v-img', {
      attrs: {
        "src": treatmentImage.src,
        "height": "fit-content"
      }
    }), _vm._v(" "), _c('v-card-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getFileName(treatmentImage.src)))])], 1)], 1)
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 skew-cc"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "treatments-intro"
    }
  }, [_c('b', {
    staticClass: "underline"
  }, [_vm._v("Mise au point :")]), _vm._v(" Les explications et exemples de traitements ont été mis à votre disposition pour vous donner un maximum d'informations sur la structure et les thérapeutiques possibles. Ces informations visent à faciliter l'accessibilité du cabinet et à préparer le dialogue lors du premier rendez-vous d'information. Elles ne sauraient donc remplacer la relation du praticien avec le patient, base de tout rapport de confiance, mais simplement la compléter et répondre à des questions ponctuelles.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 horizontal-divider row"
  }, [_c('span', {
    staticClass: "col-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 horizontal-divider row"
  }, [_c('span', {
    staticClass: "col-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 horizontal-divider row"
  }, [_c('span', {
    staticClass: "col-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 horizontal-divider row"
  }, [_c('span', {
    staticClass: "col-3"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23c7d61a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c7d61a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/pages/treatments/treatments.component.html
// module id = 264
// module chunks = 1